import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/databurst_logo.png';
import logoInverted from '../assets/databurst_logo_inverted.png';

type BrandProps = {
  className?: string;
};

// Databurst Technologies wordmark. Shows the black logo in light mode and the
// white (inverted) logo in dark mode. Links to the home page.
function Brand({ className = 'h-[58px]' }: BrandProps) {
  return (
    <Link to="/" aria-label="Databurst Technologies - home" className="inline-flex items-center">
      <img
        src={logo}
        alt="Databurst Technologies"
        className={`${className} w-auto block dark:hidden`}
      />
      <img
        src={logoInverted}
        alt="Databurst Technologies"
        aria-hidden="true"
        className={`${className} w-auto hidden dark:block`}
      />
    </Link>
  );
}

export default Brand;
